import React from "react";
import style from "./BesoinAideCard.module.css";

function BesoinAideCard(props) {
  return (
    <div className={style.card}>
      <p className={style.title}>{props.title}</p>
      <p className={style.description}>{props.description}</p>
    </div>
  );
}

export default BesoinAideCard;
